import {
  withExport,
  withResourceState,
} from '@kinet-open-network/client/shared/data-access/state';
import { signalStore } from '@ngrx/signals';
import { DiscountCodesService } from '../services/discount-codes.service';

export const DiscountCodesStore = signalStore(
  { protectedState: false }, withResourceState(DiscountCodesService),
  withExport(DiscountCodesService),
);
